webpackJsonp([29],{

/***/ 1061:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_privacy_vue__ = __webpack_require__(1117);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b823ff8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_privacy_vue__ = __webpack_require__(1196);
var normalizeComponent = __webpack_require__(24)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_privacy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b823ff8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_privacy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1117:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(73);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      is_mobile_app: 0

    };
  },

  watch: {

    "$route.query": {
      handler: function handler(newVal, oldVal) {
        var _this = this;

        console.log({ newVal: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, newVal), oldVal: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, oldVal) });
        var is_mobile_app = parseInt(newVal.is_mobile_app) || 0;

        this.$nextTick(function () {
          if (!!is_mobile_app) {
            _this.is_mobile_app = is_mobile_app;
          }
        });
      },

      immediate: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])(['isRTL']))
});

/***/ }),

/***/ 1196:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.is_mobile_app ? '': 'wrapper'},[_c('section',{staticClass:"row back_white mb-3 mx-md-3"},[_c('div',{staticClass:"col-12 d-flex justify-content-center"},[_c('h3',{staticClass:"static_title"},[_vm._v(_vm._s(_vm.$t("PRIVACYPOLICY")))])]),_vm._v(" "),_c('div',{staticClass:"col-12 mt-3",class:_vm.isRTL ? 'rtl text-right' : ''},[_c('p',[_vm._v("\n          "+_vm._s(_vm.$t("REFERRED_TO"))+" \n       ")])]),_vm._v(" "),_c('div',{staticClass:"col-12 d-block mt-3",class:_vm.isRTL ? 'rtl text-right' : ''},[_c('span',{staticClass:"font-weight-bold",staticStyle:{"color":"#ED5965"}},[_vm._v(_vm._s(_vm.$t("WHAT_INFORMATION"))+" ?")]),_vm._v(" "),_c('p',{staticClass:"mt-2"},[_vm._v("\n          "+_vm._s(_vm.$t("WE_OFFER"))+"\n       ")])]),_vm._v(" "),_c('div',{staticClass:"col-12 d-block mt-3",class:_vm.isRTL ? 'rtl text-right' : ''},[_c('span',{staticClass:"font-weight-bold",staticStyle:{"color":"#ED5965"}},[_vm._v(_vm._s(_vm.$t("WHAT_INFORMATION_FOR")))]),_vm._v(" "),_c('p',{staticClass:"mt-2"},[_vm._v("\n          "+_vm._s(_vm.$t("ANY_INFORMATION"))+"\n       ")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v(_vm._s(_vm.$t("PERSONALIZE_ENHANCE")))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t("IMPROVE_WEBSITE")))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t("IMPROVE_CUSTOMER")))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t("PROCESS_TRANSACTIONS")))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t("ADMINISTER_CONTEST")))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t("SEND_PERIODIC")))])]),_vm._v(" "),_c('p',{staticClass:"mt-3",staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.$t("NOTE_UNSUBSRICBE"))+"\n   ")])]),_vm._v(" "),_c('div',{staticClass:"col-12 d-block mt-3",class:_vm.isRTL ? 'rtl text-right' : ''},[_c('span',{staticClass:"font-weight-bold",staticStyle:{"color":"#ED5965"}},[_vm._v(_vm._s(_vm.$t("ACCESSING_UPDATING")))]),_vm._v(" "),_c('p',{staticClass:"mt-2"},[_vm._v("\n          "+_vm._s(_vm.$t("WHEN_YOU_USE_OUR_SERVICES"))+"\n       ")])]),_vm._v(" "),_c('div',{staticClass:"col-12 d-block mt-3",class:_vm.isRTL ? 'rtl text-right' : ''},[_c('span',{staticClass:"font-weight-bold",staticStyle:{"color":"#ED5965"}},[_vm._v(_vm._s(_vm.$t("DO_COOKIES")))]),_vm._v(" "),_c('p',{staticClass:"mt-2"},[_vm._v("\n        "+_vm._s(_vm.$t("YES_COOKIES_SMALL"))+"\n       ")])]),_vm._v(" "),_c('div',{staticClass:"col-12 d-block mt-3",class:_vm.isRTL ? 'rtl text-right' : ''},[_c('span',{staticClass:"font-weight-bold",staticStyle:{"color":"#ED5965"}},[_vm._v(_vm._s(_vm.$t("DO_WE_DISCLOSE")))]),_vm._v(" "),_c('p',{staticClass:"mt-2"},[_vm._v("\n        "+_vm._s(_vm.$t("WE_DO_NOT_SELL"))+"\n       ")])]),_vm._v(" "),_c('div',{staticClass:"col-12 d-block mt-3",class:_vm.isRTL ? 'rtl text-right' : ''},[_c('span',{staticClass:"font-weight-bold",staticStyle:{"color":"#ED5965"}},[_vm._v(_vm._s(_vm.$t("THIRD")))]),_vm._v(" "),_c('p',{staticClass:"mt-2"},[_vm._v("\n        "+_vm._s(_vm.$t("OCCASIONALLY_DISCRETION"))+"\n       ")])]),_vm._v(" "),_c('div',{staticClass:"col-12 d-block mt-3",class:_vm.isRTL ? 'rtl text-right' : ''},[_c('span',{staticClass:"font-weight-bold",staticStyle:{"color":"#ED5965"}},[_vm._v(_vm._s(_vm.$t("TERMS_AND_CONDITIONS")))]),_vm._v(" "),_c('p',{staticClass:"mt-2"},[_vm._v("\n       "+_vm._s(_vm.$t("PLEASE_ALSO_VISIT"))+" \n        "),_c('a',{staticStyle:{"color":"#337ab7"},attrs:{"href":"https://www.wanasatime.com"}},[_vm._v("https://www.wanasatime.com")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 d-block mt-3",class:_vm.isRTL ? 'rtl text-right' : ''},[_c('span',{staticClass:"font-weight-bold",staticStyle:{"color":"#ED5965"}},[_vm._v(_vm._s(_vm.$t("YOUR_CONSENT")))]),_vm._v(" "),_c('p',{staticClass:"mt-2"},[_vm._v("\n        "+_vm._s(_vm.$t("BY_USING"))+"\n       ")])]),_vm._v(" "),_c('div',{staticClass:"col-12 d-block mt-3",class:_vm.isRTL ? 'rtl text-right' : ''},[_c('span',{staticClass:"font-weight-bold",staticStyle:{"color":"#ED5965"}},[_vm._v(_vm._s(_vm.$t("DISCLAIMERS")))]),_vm._v(" "),_c('p',{staticClass:"mt-2"},[_vm._v("\n     "+_vm._s(_vm.$t("WHENEVER_YOU_VOLUNTARILY"))+"\n       ")])]),_vm._v(" "),_c('div',{staticClass:"col-12 d-block mt-3",class:_vm.isRTL ? 'rtl text-right' : ''},[_c('span',{staticClass:"font-weight-bold",staticStyle:{"color":"#ED5965"}},[_vm._v(_vm._s(_vm.$t("CHANGES_PRIVACY")))]),_vm._v(" "),_c('p',{staticClass:"mt-2"},[_vm._v("\n    "+_vm._s(_vm.$t("PLEASE_NOTE_PRIVACY"))+"\n       ")])]),_vm._v(" "),_c('div',{staticClass:"col-12 d-block mt-3",class:_vm.isRTL ? 'rtl text-right' : ''},[_c('span',{staticClass:"font-weight-bold",staticStyle:{"color":"#ED5965"}},[_vm._v(_vm._s(_vm.$t("CONTACT_US")))]),_vm._v(" "),_c('p',{staticClass:"mt-2"},[_vm._v("\n   "+_vm._s(_vm.$t("PROTECT_PRIVACY"))+"\n       ")]),_vm._v(" "),_c('p',{staticClass:"mt-5",class:_vm.isRTL ? 'rtl text-right' : ''},[_vm._v("\n           "+_vm._s(_vm.$t("EMAIL"))+": "),_c('a',{staticStyle:{"color":"#337ab7"},attrs:{"href":"mailto:hello@wanasatime.com"}},[_vm._v("hello@wanasatime.com")]),_c('br'),_vm._v("\n           "+_vm._s(_vm.$t("PHONE"))+": +973 13633334\n       ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/29.f9f0635a7495161eee84.js